export const USER_TYPES = {
    Business: 'Business',
    Internal: 'Internal',
} as const;
export type UserTypes = (typeof USER_TYPES)[keyof typeof USER_TYPES];

export const INTERNAL_ROLES = {
    Admin: 'Admin',
    Service: 'Service',
} as const;
export type InternalRoles =
    (typeof INTERNAL_ROLES)[keyof typeof INTERNAL_ROLES];

export const BUSINESS_ROLES = {
    Bartender: 'Bartender',
    Manager: 'Manager',
    Owner: 'Owner',
} as const;
export type BusinessRoles =
    (typeof BUSINESS_ROLES)[keyof typeof BUSINESS_ROLES];

export const ROLES = {
    ...INTERNAL_ROLES,
    ...BUSINESS_ROLES,
} as const;
export type Roles = InternalRoles | BusinessRoles;

export const ACCOUNT_TYPES = {
    User: 'User',
    Customer: 'Customer',
} as const;
export type AccountTypes = (typeof ACCOUNT_TYPES)[keyof typeof ACCOUNT_TYPES];
